import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { ReportsService } from 'src/app/services/reports.service';
import { UserService } from 'src/app/services/user.service';
import { ApproveDialogComponent } from '../../approve-dialog/approve-dialog.component';
import { CommonPdfComponent } from '../../common-pdf/common-pdf.component';
import { OrderSummaryResponse } from '../../model/ordersummaryresponse';
import { SortableColumn } from '../../model/sort/sortable-column';
import { UserData } from '../../model/user-data';
import { UsersDataResponse } from '../../model/users-data-response';
import { merge, Observable, of as observableOf } from 'rxjs';
import { catchError, map, startWith, switchMap } from 'rxjs/operators';
@Component({
    selector: 'app-exception-report',
    templateUrl: './exception-report.component.html',
    styleUrls: ['./exception-report.component.scss'],
    standalone: false
})
export class ExceptionReportComponent extends CommonPdfComponent implements OnInit {
  resultsLength = 0;
  isLoadingResults = true;
  isRateLimitReached = false;
  
  exceptionForm: UntypedFormGroup;
  storeData:[]=[];
  storeNumber:string=null;
  dcNumber:number=null;
   filter:string='';
  minDate:Date=new Date();
  maxDate:Date=new Date();
  sortableColumn:SortableColumn;
  options:string[]=[];
  isDataloaded:boolean=true;
  displayedColumns: string[] = ['purchaseOrder', 'poCreatedTime', 'poReceivedDate', 'signedBy'];
  dataSource: MatTableDataSource<OrderSummaryResponse>;
  dateTimeFormat:string='yyyy-MM-dd hh:mm:ss a';
  dateFormat:string='yyyy-MM-dd';
  storesOptions: string[] = [];
  filteredStoreOptions: Observable<string[]>;

  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  
  displayFn(storeData): string {
    return storeData ? storeData : '';
  }

  private _filter(name: string): string[] {
    const filterValue = name.toLowerCase();

    return this.options.filter(option => option.toLowerCase().indexOf(filterValue) === 0);
  }
  constructor(private route: ActivatedRoute,private userservice:UserService,
    private reportsService: ReportsService, private fb: UntypedFormBuilder,private router:Router,protected dialog:MatDialog) {
      super(dialog);
     }

  
  userData:UserData;
  user:UsersDataResponse;
  


  
  ngOnInit(): void {
    
  this.userservice.getCurrentUser().subscribe(data=>{
    this.user=data;
    this.userData=data.userData;
    this.storesOptions=this.user.stores?this.user.stores.map(value => (value.storeNumber)):null;
    let lang=this.userData.language.toLowerCase();
    if(lang==='fr'){
      this.dateTimeFormat="medium";
     this.dateFormat="mediumDate"

    }
    if(this.userData.roleId<4){
      this.createFormDC();
      }else{
        this.createFormStore();
      }

      this.filteredStoreOptions = this.exceptionForm.controls.storeNumber.valueChanges
      .pipe(
        startWith(''),
        map(value => this.store_filter(value))
      );

  })        
   
  }
  
  private store_filter(value: string): string[] {  
    const filterValue =  value !== null ? value.toLowerCase() : '';    
    if(value.charAt(0)==='0'){
     let options=this.storesOptions?this.storesOptions.filter(option => option.toLowerCase().startsWith(filterValue)):null; 
     options.sort((a,b) =>  (a > b ? 1 : -1));
     return options;

   }else{
     if(this.storesOptions){
      let options= this.storesOptions.filter(option => parseInt(option).toString().toLowerCase().startsWith(filterValue));
         options.sort((a,b) =>  (a > b ? 1 : -1));
     return options;
     }else{
       return null;
     }
    
   }
  }

  dcOnchange(){
    let dc=this.exceptionForm.controls.dcNumber.value;
    this.storesOptions=this.user.stores?this.user.stores.filter(option => option.dcNumber===dc).map(value => (value.storeNumber)):null;  
    this.exceptionForm.controls.storeNumber.setValue("");
    this.store_filter('');
  }
    

  createFormDC() {
    this.exceptionForm = this.fb.group({
      storeNumber: [''],
      dcNumber:['',Validators.required],
      fromDate:['',Validators.required],
      toDate:['',Validators.required],
          
    });

  }

   

  createFormStore() {
    this.exceptionForm = this.fb.group({
      storeNumber: ['', Validators.required],
      dcNumber:[null,],
      fromDate:['',Validators.required],
      toDate:['',Validators.required],
          
    });

  }

  padLeft(text:string, padChar:string, size:number): string {
    return (String(padChar).repeat(size) + text).substr( (size * -1), size) ;
  }

  getExceptionesults(){
    this.dataSource = new MatTableDataSource<OrderSummaryResponse>();
    let fromDate = JSON.stringify(this.exceptionForm.controls.fromDate.value)
    fromDate = fromDate.slice(1,11);
    let toDate = JSON.stringify(this.exceptionForm.controls.toDate.value)
    toDate = toDate.slice(1,11);
    let sn=this.exceptionForm.controls.storeNumber.value;
    if(sn && sn.length<6){
      this.exceptionForm.controls.storeNumber.setValue(this.padLeft(sn,'0',6));
    }
    this.reportsService.getExceptionResults(this.exceptionForm.value,fromDate,toDate).subscribe(data=>{
    this.dataSource=new MatTableDataSource<OrderSummaryResponse>(data);
    this.dataSource.paginator=this.paginator;
    this.dataSource.sort=this.sort;
    },(error:HttpErrorResponse)=>{
     
      if(error && error.status===404){
      let dialogData= {
        title: this.userData.language==="EN"?'No Records Found':"Aucune transaction trouvée",
        message: this.userData.language==="EN"?"No records to display.":"Aucune transaction à afficher",
       
      }
      this.dialog.open(ApproveDialogComponent,{
        data:dialogData,panelClass: 'my-class'
      });
    }
  }
    
    )
  }

 

  openReportBySeq(sequenceNumber){
    
  this.reportsService.getExceptionReport(sequenceNumber).subscribe(data=>{
    this.isDataloaded=true;
    let contentDispositionHeader= data.headers.get('Content-Disposition')
    var result = contentDispositionHeader.split(';')[1].trim().split('=')[1];
    result.replace(/"/g, '');
    console.log(result);
    this.isDataloaded=true;
   let dialogData= {
    title: result,
      downloadFileName: result,
      downLoadFile:true
    }
    this.openReport(data.body,dialogData);
  //   this.dialog.open(PdfViewerComponent, {
  //     width: '100%',
  //     maxWidth: '90%',
  //     height: 'auto',
  //     data: {
  //       title: 'TEST',
  //       srcType: 'Binary',
  //       pdfData: new Blob([data], { type: 'application/pdf' }),
  //       downloadFileName: "Test.pdf",
  //       downLoadFile:true
  //     }
  //   });
   },(error:HttpErrorResponse)=>{
     
    if(error && error.status===404){
    let dialogData= {
      title: this.userData.language==="EN"?'No Records Found':"Aucune transaction trouvée",
      message: this.userData.language==="EN"?"No records to display.":"Aucune transaction à afficher",
    }
    this.dialog.open(ApproveDialogComponent,{
      data:dialogData,panelClass: 'my-class'
    });
  }
})
 
  }

  
  

  
  sortData(sort: Sort) {   
    this.sortableColumn=new SortableColumn('','','');
    const sortedData: boolean | Array<any> = this.sortableColumn.sortTableData(sort, this.dataSource.data, this.displayedColumns);    
    if (sortedData) {
      this.dataSource.data = sortedData as Array<any>;
    }
  }


advancedSearch(){
    console.log(this.filter);
    console.log(this.filter);
}


}
